const Element_Ids = {
  price: 'upsell-price',
  priceTargetElement: 'upsell-price-target',
  varaintSelector: 'upsell-variant-selector-',
  addOnItemContainer: 'upsell-addon-',
  uiBlockWrapper: 'upsell-ui-block-wrapper'
};

export default Element_Ids;
